import { SourceType } from 'components/organisms/tasks/fields';

export enum FilterGroupType {
  Task = SourceType.Task,
  Project = SourceType.Project,
  User = SourceType.User,
}
